import { useState } from "react";

const Icon = ({icon, text}) => {
    let url = useState('');
    
    if (text === 'Github') {
        url = "https://github.com/Shoaib1990?tab=repositories";
    } else if (text === 'Email') {
        url = "mailto:ds.shoaibkhalid@gmail.com"
    } else if (text === 'Linkedin') {
        url = "https://linkedin.com/in/shoaib-khalid/"
    } else if (text === 'Resume') {
        url = "https://ds.shoaibkhalid.ca/Resume.pdf"
    } 

    return (
        <a href={url} className={`col icon ${text}`} target="_blank">
            <div className="d-flex justify-content-center">
                <img className="icon-img col" src={icon}></img>
                <p className="icon-text link-dark">
                {text}    
                </p>
            </div>
        </a>
    )
}

export default Icon;